var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-uploader"},[_c('input',{ref:"imagefile",staticClass:"hidden",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.selectPhoto}})])}
var staticRenderFns = []

export { render, staticRenderFns }